import { useEffect } from "react";
import { SITE_URL } from "@/data";

const DEFAULT_OG_IMAGE = `${SITE_URL}/og-default.jpg`;
const SITE_NAME = "Glebe Park Dental";

const upsert = (selector, tag, attrs) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(tag);
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
};

export const useSEO = ({
  title,
  description,
  path,
  jsonLd,
  ogImage,
  ogType = "website",
  noindex = false,
}) => {
  const url = `${SITE_URL}${path}`;
  const image = ogImage
    ? ogImage.startsWith("http")
      ? ogImage
      : `${SITE_URL}${ogImage}`
    : DEFAULT_OG_IMAGE;
  const ld = jsonLd ? JSON.stringify(jsonLd) : null;

  useEffect(() => {
    document.title = title;
    upsert('meta[name="description"]', "meta", { name: "description", content: description });
    upsert('meta[name="robots"]', "meta", {
      name: "robots",
      content: noindex ? "noindex, follow" : "index, follow",
    });
    upsert('link[rel="canonical"]', "link", { rel: "canonical", href: url });

    upsert('meta[property="og:type"]', "meta", { property: "og:type", content: ogType });
    upsert('meta[property="og:site_name"]', "meta", { property: "og:site_name", content: SITE_NAME });
    upsert('meta[property="og:locale"]', "meta", { property: "og:locale", content: "en_AU" });
    upsert('meta[property="og:title"]', "meta", { property: "og:title", content: title });
    upsert('meta[property="og:description"]', "meta", { property: "og:description", content: description });
    upsert('meta[property="og:url"]', "meta", { property: "og:url", content: url });
    upsert('meta[property="og:image"]', "meta", { property: "og:image", content: image });

    upsert('meta[name="twitter:card"]', "meta", { name: "twitter:card", content: "summary_large_image" });
    upsert('meta[name="twitter:title"]', "meta", { name: "twitter:title", content: title });
    upsert('meta[name="twitter:description"]', "meta", { name: "twitter:description", content: description });
    upsert('meta[name="twitter:image"]', "meta", { name: "twitter:image", content: image });

    document.head
      .querySelectorAll('script[data-page-schema="true"]')
      .forEach((s) => s.remove());
    if (!ld) return undefined;
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.setAttribute("data-page-schema", "true");
    script.text = ld;
    document.head.appendChild(script);
    return () => script.remove();
  }, [title, description, url, image, ld, noindex, ogType]);
};
